import dayjs from "dayjs"

import { createSlice, PayloadAction } from "@reduxjs/toolkit"

type MobileAppState = {
  selectedDay: string
  isBookingSheetOpen: boolean
  hasMadeInitialBookingDecision: boolean
}

const initialState: MobileAppState = {
  selectedDay: dayjs().startOf("day").toISOString(),
  isBookingSheetOpen: false,
  hasMadeInitialBookingDecision: false,
}

const mobileAppSlice = createSlice({
  name: "mobileApp",
  initialState,
  reducers: {
    setSelectedDay: (state, { payload }: PayloadAction<string>) => {
      state.selectedDay = payload
    },
    setIsBookingSheetOpen: (state, { payload }: PayloadAction<boolean>) => {
      state.isBookingSheetOpen = payload
    },
    markInitialBookingDecisionMade: (state) => {
      state.hasMadeInitialBookingDecision = true
    },
  },
})

export const mobileAppReducer = mobileAppSlice.reducer
export const {
  setSelectedDay,
  setIsBookingSheetOpen,
  markInitialBookingDecisionMade,
} = mobileAppSlice.actions
